// extracted by mini-css-extract-plugin
export default {"link":"Dapps_link__CKxVf","list":"Dapps_list__4QaNL"};